import { useEffect, useRef, useState } from "react";
import { execSeatableSql } from './seatable.js';
import Accordion from 'react-bootstrap/Accordion';

// const data = [
//     { question: "Create transparency of technology spending for IT, Finance and the Business", answer: "Translate spending from the traditional technical components—cloud, data center, third party software to name a few—into outcomes that the business understands and cares about. Use technology business management practices to connect tech investments to business value."},
//     { question: "Unlock savings from non-discretionary expenses and investments with low returns", answer: "Demand rationalization is simple in concept but difficult in execution, especially when dealing with internal workforce productivity. Seize the chance to identify, quantify, and capture savings from third party spend and investments that generate a low return."},
//     { question: "Align technology investment with business value", answer: "Remediating tech debt can be expensive, and low-value tech transformation is often required to shift IT investment from \"run\" to \"grow\". Introduce tools and processes to forge a continuous link between tech investment and achieving target business outcomes."}
// ];

function DomainTopics(props) {
    const [activeKey, setActiveKey] = useState(null);
    const accordionRef = useRef(null);
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM \`Domain Topics\` WHERE \`Capability\` IN ('${props.capability}')`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          const rowData = rows && rows.results;
          setData(rowData);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]); 

    function useOutsideClick(ref, callback) {
        useEffect(() => {
            const handleClick = (e) => {
                if (ref.current && !ref.current.contains(e.target)) callback();
            };
            document.addEventListener("mousedown", handleClick);
            return () => document.removeEventListener("mousedown", handleClick);
        }, [ref, callback]);
    }

    useOutsideClick(accordionRef, () => setActiveKey(null));

    return (
    <div className="domain-topics pb-5 border-bottom border-secondary">
        {data && (data.length > 0) ? <>
            <div className="my-5 d-flex justify-content-center">
                <h1>Inside the Domain</h1>
            </div>
            <div className="w-100">
                <Accordion 
                    className="all-accordion" 
                    activeKey={activeKey} 
                    onSelect={(key) => setActiveKey(activeKey === key ? null : key)} 
                    ref={accordionRef}
                >
                    {data.map((row, index) => {
                        return (
                            <Accordion.Item key={index} eventKey={index}>
                                <Accordion.Header>{row.Topic}</Accordion.Header>
                                <Accordion.Body>{row.Detailed}</Accordion.Body>
                            </Accordion.Item>
                        )
                    })}
                </Accordion>
            </div>
        </> : ''}
    </div>
    )
}

export default DomainTopics;